/* 
FireStore services 
*/
import firebase from "../../config/firebase";
import axios from "axios";
import { baseUrl } from "../../config/app.config";

/* 
Firebase and DB accesses and requests for the SalesReport 
*/

//fetching the catagory list to populate the projection cards
export const GetCategoryListDetails = async (
  area,
  team,
  office,
  financialYear,
  month,
  reportName,
  groupBy
) => {
  let result = { error: false, data: "" };

  var areaTeamBranch = getAreaTeamBranchForGroupBy(area, team, office, groupBy);

  try {
    var response = await axios.get(
      baseUrl +
        "/api/Sales/GetDashboardCards?marea=" +
        areaTeamBranch.area +
        "&mteam=" +
        areaTeamBranch.team +
        "&office=" +
        areaTeamBranch.branch +
        "&financialYear=" +
        financialYear +
        "&mmonth=" +
        month +
        "&reportName=" +
        reportName +
        "&groupBy=" +
        groupBy
    );

    result.data = response.data;
  } catch (error) {
    result.error = true;
    result.data = null;
  }

  return result;
};

//fetching the data for populating the filterchange dropdown

export const GetReportFiterPeriods = () => {
  let date = new Date();
  return firebase
    .collection("ReportFilter")
    .where("ReportType", "==", "Sales")
    .where("EndDate", "<=", date)
    .get();
};

// Format area team branch parameters based on group by
export const getAreaTeamBranchForGroupBy = (area, team, branch, groupBy) => {
  var obj = { area: area, team: team, branch: branch };

  switch (groupBy) {
    case "All":
      obj.area = 0;
      obj.team = 0;
      obj.branch = 0;
      break;

    case "Area":
      obj.team = 0;
      obj.branch = 0;
      break;

    case "Team":
      obj.branch = 0;
      break;
  }

  return obj;
};
